import styled from 'styled-components';

export const CharListItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    cursor: pointer;
    padding: 10px;

    :hover {
        background-color: #444;
    }

    &.expanded,
    &:first-child {
        margin-top: 10px;
    }
`;

export const CharListAvatar = styled.div`
    width: 40px;
    height: 40px;
    background-color: transparent;
    margin-right: 10px;
    position: relative;

    &.compact {
        width: 30px;
        height: 30px;
    }
`;

export const CharListInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
`;

export const CharListName = styled.div`
    color: #ccc;
    font-size: 16px;
`;

export const CharListDetail = styled.div`
    color: #777;
    width: 100%;
    margin: 3px 0;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const CharListPlayer = styled.div`
    color: #777;
    font-size: 12px;
`;

export const CharValue = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`;

export const CharValueInput = styled.input`
    width: 35px;
    margin-left: 10px;
    text-align: center;
    color: #999;
    background-color: #111;
    border: 1px solid #444;
    border-bottom: 3px solid ${props => props.color};
    font-size: 14px;
    font-weight: 900;
    height: 35px;
`;

export const FilterField = styled.input`
    width: calc(80% - 20px);
    margin: 0 20px 20px 0;
    color: #999;
    background-color: #111;
    border: 1px solid #444;
    font-size: 14px;
    height: 30px;
    min-height: 30px;
`;

export const CharGroup = styled.div`
    margin-bottom: 30px;
`;

export const NoChars = styled.div`
    flex: 1;
    width: 100%;
    color: #666;
    text-align: center;
    padding: 0 80px;
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:before {
        font-family: 'Material Design Icons';
        font-size: 150px;
        color: #333;
        content: '\\F0859';
        margin-bottom: 80px;
    }
`;